export default "__VITE_ASSET__6a15bc8e__"